var Constants = require('../constants/Constants');
var BaseStore = require('./BaseStore');

var IpStore = new BaseStore({
    defaultData: {}
});
IpStore.loading = {};

IpStore._loadData = function (ipAddress) {
    var Api = require('../api/Invocation');

    var promise = Api.dns.getPtr(ipAddress);
    this.loading[ipAddress] = true;
    this._data[ipAddress] = null;
    this.emitChange();

    promise
        .then(({ body }) => this._data[ipAddress] = body[0] || '')
        .catch((err) => {
            if (err.response.status != 404) {
                throw err;
            }

            this._data[ipAddress] = false;
        })
        .then(() => this.loading[ipAddress] = false)
        .then(() => this.promiseChange())
        .done();
};

IpStore.getPtr = function (ipAddress) {
    if (!this._data.hasOwnProperty(ipAddress)) {
        this._loadData(ipAddress);

        return;
    }

    return this._data[ipAddress];
};

IpStore.ptrLoading = function (ipAddress) {
    return this.loading.hasOwnProperty(ipAddress) && this.loading[ipAddress];
};

module.exports = IpStore;



// WEBPACK FOOTER //
// ./app/stores/IpStore.js